import { filterFileAttachments, filterUploadingAttachments } from '@/components/Attachment/utils'
import { Button, type ButtonProps } from '@ruguoapp/jike-fe-components'
import { isEmpty } from 'lodash-es'
import { useWatch } from 'react-hook-form'
import type { PostFormValue } from './schemas'

export interface SubmitButtonProps extends ButtonProps {}

export default function SubmitButton({ ...props }: SubmitButtonProps) {
	const content = useWatch<PostFormValue, 'content'>({
		name: 'content',
	})
	const attachments = useWatch<PostFormValue, 'attachments'>({
		name: 'attachments',
	})
	const uploadingAttachments = filterUploadingAttachments(filterFileAttachments(attachments))
	const hasUploadingAttachments = uploadingAttachments.length > 0

	const isDisabled = (isEmpty(content) && attachments.length === 0) || hasUploadingAttachments

	return (
		<Button disabled={isDisabled} appearance="primary" size="sm" type="submit" {...props}>
			发送
		</Button>
	)
}
